import commonDataAccess from "../commonDataAccess";
import { IFilter } from "src/@redux/listRedux";

class RiskAnalysisQuestionnaireDataAccess {
  saveProductSupplierRiskAnalysis(payload: {
    Id: any;
    ProductId: number;
    ProductRiskAnalysisId: any;
    SupplierId: any;
    IssueDate: any;
    DeadlineDate: any;
    EmailRecipentName: any;
    EmailAddress: any;
    SentBy: any;
    IsSent: boolean;
    IsNotify: boolean;
  }) {
    return commonDataAccess.postData(
      "RiskAnalysisQuestionnaire/save/productSupplierRiskAnalysis",
      payload
    );
  }
  getCompletedGeneralInfo(id: any) {
    return commonDataAccess.getData(
      "RiskAnalysisQuestionnaire/get/completed-riskanalysis/" + id
    );
  }

  getRiskAnalysis() {
    return commonDataAccess.getData(
      "RiskAnalysisQuestionnaire/get/riskanalysis-dropdowndata"
    );
  }
  getRiskAnalysisQuestionnaire = () => {
    return commonDataAccess.getData(
      "RiskAnalysisQuestionnaire/getRiskAnalysisQuestionnaires"
    );
  };

  getProductRiskAnalysis(productId: number) {
    return commonDataAccess.getData(
      "RiskAnalysisQuestionnaire/get/productRiskAnalysis",
      {
        productId: productId,
      }
    );
  }

  saveProductRiskAnalysis = (data: any) => {
    return commonDataAccess.postData(
      "RiskAnalysisQuestionnaire/save/productRiskAnalysis",
      data
    );
  };
  requestQuestionnaireToBeCompleted = (data: any) => {
    return commonDataAccess.postData(
      "RiskAnalysisQuestionnaire/email-questionnaire-to-product",
      data
    );
  };

  verifyProductRiskAnalysisToken = (params: {
    productId: number;
    questionId: number;
    token: string;
  }) => {
    return commonDataAccess.postData(
      "ProductRiskAnalysisProcess/verify-token-getProductProcessQuestionnaire",
      params
    );
  };

  getList = (params: {
    pageNo;
    pageSize;
    sortData;
    filters: Array<IFilter>;
  }) => {
    let _filters = {};
    params.filters.forEach((item) => {
      if (item.value && item.value.length > 0) {
        _filters["filter." + item.propertyName] = item.value + "-" + item.type;
      }
    });
    let parameters = {
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      sortPreference: params.sortData,
      ..._filters,
    };

    return commonDataAccess.getData(
      "RiskAnalysisQuestionnaire/getall",
      parameters
    );
  };

  getGeneralInfo = async (params: { id: number | bigint }) => {
    var result = await commonDataAccess.getData(
      "RiskAnalysisQuestionnaire/get/generalinfo/" + params,
      {}
    );
    return result;
  };

  saveGeneralInfo = (data: any) => {
    return commonDataAccess.postData(
      "RiskAnalysisQuestionnaire/save/generalinfo",
      data,
      {
        // id: id,
      }
    );
  };

  deleteRiskAnalysisInfo = (ids: number | number[]) => {
    if (Array.isArray(ids)) {
      return commonDataAccess.postData(
        "RiskAnalysisQuestionnaire/deleteAll",
        ids
      );
    } else {
      return commonDataAccess.deleteData(
        `RiskAnalysisQuestionnaire/delete/${ids}`
      );
    }
  };

  notifyRecipientToComplete = (data: any) => {
    return commonDataAccess.postData(
      "RiskAnalysisQuestionnaire/notify-recipient-to-complete",
      data
    );
  };

  getCompletedRAList = (params: {
    pageNo;
    pageSize;
    sortData;
    filters: Array<IFilter>;
  }) => {
    let _filters = {};
    params.filters.forEach((item) => {
      if (item.value && item.value.length > 0) {
        _filters["filter." + item.propertyName] = item.value + "-" + item.type;
      }
    });
    let parameters = {
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      sortPreference: params.sortData,
      ..._filters,
    };

    return commonDataAccess.getData(
      "RiskAnalysisQuestionnaire/getall-completed-RA",
      parameters
    );
  };

  getProductRiskAnalysisQuestions(productRiskAnalysisId: number) {
      return commonDataAccess.getData(
        "RiskAnalysisQuestionnaire/get/riskAnalysisQuestions",
        {
          productRiskAnalysisId: productRiskAnalysisId,
        }
      );
    }
  
  saveProductRiskAnalysisAnswers = (data: any) => {
    return commonDataAccess.postData(
      "RiskAnalysisQuestionnaire/save/productRiskAnalysisAnswers",
      data
    );
  }

    saveImageStep(data: { ProductRiskAnalysisAnswerId: any; image: any }) {
      return commonDataAccess.postData(
        "RiskAnalysisQuestionnaire/save/imageStep",
        data
      );
    }
    saveSignatureStep(data: {
      ProductRiskAnalysisAnswerId: any;
      signature: any;
    }) {
      return commonDataAccess.postData(
        "RiskAnalysisQuestionnaire/save/signatureStep",
        data
      );
    }
    saveAttachments = (
      payload: FormData,
      docHistoryName: string,
      classType: string
    ) => {
      return commonDataAccess.postFormData(
        "RiskAnalysisQuestionnaire/save/attachments",
        payload,
        {
          classType: classType,
        }
      );
    };
}

export default new RiskAnalysisQuestionnaireDataAccess();
